export const defaultSettings = {
    configuration:
        {
            confirmSiteRangeMts: 10
        }
}